// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_EuX","cls2":"ExportFormatModal-cls2_x7- ExportFormatModal-cls1_EuX"};